// extracted by mini-css-extract-plugin
export default {"children":"ma1l6s","childrenActive":"XbiP78","list":"_mwTVM","listActive":"ule4ev","others":"MtF3K9","handle":"whBz6m","name":"OF_VMY","previous":"KAFAVR"};